<template>
    <div>
        <div class="modal fade modal__custom modal__toast" :id="'AlertModal'+modalId" tabindex="-1" role="dialog"
             aria-labelledby="AlertModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title  h_text" :class="getClass" id="AlertModaTitle">{{ title }}</h5>
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                                id="AlertModalBtnClose"></button>
                    </div>
                    <div class="modal-body color__gray_1">
                        <p>{{ message }}</p>
                        <template v-if="promos.length">
                            <table class="table table__order_payment">
                                <tbody>
                                <tr v-for="(promo , key) in promos" class="d-flex justify-content-between">
                                    <td class="d-flex flex-column">
                                        <span>{{ get_translation_constant('text_order_number') }}
                                            {{promo.parcel.id }}
                                        </span>
                                        <span>{{ get_translation_constant('text_promo_code') }}</span>
                                        <span>{{ get_translation_constant('text_total') }}</span>
                                    </td>
                                    <td class="d-flex flex-column">
                                        <span>{{ promo.old_price }} $</span>
                                        <span>{{ promo.discount }} $</span>
                                        <span>{{ promo.parcel.total_price }} $</span>
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <a :id="'AlertModalBtn'+modalId" class="btn btn__large btn__blue_border no_width opacity-0 d-none"
           href="javascript:void(0)"
           data-bs-toggle="modal" :data-bs-target="'#AlertModal'+modalId">+</a>
    </div>
</template>

<script>
export default {
    name: "AlertModal",
    props: {
        title: {
            type: [String]
        },
        type: {
            type: [String]
        },
        message: {
            type: [String]
        },
        modalId: {
            type: [String],
            default: ''
        },
        promos: {
            type: [Array],
            default: () => []
        },
        translations: {
            type: [Array],
            default: () => []
        },
        lng: {
            type: [String],
            default: () => 'en'
        },
    },
    computed: {
        getClass() {
            if (this.type === 'success') {
                return 'color__green';
            }
            return 'color__red';
        }
    },
    methods: {
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
    }
}
</script>

<style scoped>

</style>
